module.exports = __webpack_public_path__ + "img/silky.ea595ce0.png";